// extracted by mini-css-extract-plugin
export default {"profile-data":"Activity_profile-data__qiEFF","Activity-feed":"Activity_Activity-feed__eUJ1M"};